import { render, staticRenderFns } from "./AggregatePayment.vue?vue&type=template&id=7b230e74&scoped=true"
import script from "./AggregatePayment.vue?vue&type=script&lang=js"
export * from "./AggregatePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b230e74",
  null
  
)

export default component.exports